const getters = {
    isSurveyExpired: (state) => {
        let endDate = new Date(state.surveyDetails.endDate);
        let today = new Date();
        if (endDate < today) {
            return true
        }
        return false
    },
};

export default getters;
